import { render } from "./DropdownNav.vue?vue&type=template&id=3a4fa368"
import script from "./DropdownNav.vue?vue&type=script&lang=js"
export * from "./DropdownNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__